import React from 'react';
import type { FC } from 'react';
import type { Portfolio } from 'venn-api';
import { DepthTreeView } from './DepthTreeView';

interface PortfolioTreeProps {
  portfolio: Partial<Portfolio>;
  depth: number;
}

export const PortfolioTreeView: FC<PortfolioTreeProps> = ({ portfolio, depth }) => {
  return (
    <DepthTreeView<Partial<Portfolio>>
      root={portfolio}
      maxDepth={depth}
      getKey={(p) => String(p.id ?? '')}
      getChildren={(p) => p.children as Partial<Portfolio>[] | []}
      getLabel={(p) => p.name ?? ''}
    />
  );
};
